<template>
  <div class="video">
    <control :videoSrc="curPlaying.PlayUrl" :curClass="curClass" :mainConfig="mainConfig" :loginStatus="loginStatus" />
    <list :auditionCourseList="auditionCourseList" :curPlaying="curPlaying" @changeCurPlaying="item => curPlaying = item" :phone="phone" />
  </div>
</template>

<script>
import control from "./cell/control"
import list from "./cell/list"
export default {
  name: "Video",
  components: {
    control,
    list
  },
  props: {
    auditionCourseList: {
      type: Array,
      default: () => []
    },
    phone: {
      type: String,
      default: ""
    },
    mainConfig: {
      type: Object,
      default: () => {}
    },
    loginStatus: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      curPlaying: {},
      curClass: {
        ClassEName: "jzs1"
      }
    }
  },
  created() {
    this.changeCurPlaying(this.auditionCourseList[0])
  },
  methods: {
    changeCurPlaying(item) {
      this.curPlaying = item
    }
  }
}
</script>

<style lang="scss" scoped>
.video{
  margin: 0 auto;
  width: 1200px;
  height: 446px;
  display: flex;
  background: #101010;
}
</style>